import { PickKeyOfObject, PickKeyOfString, PickObjectRecursive } from "@/common/declare";
import { observable } from "vue/types/umd";

const properNoun = {

}

const dlc = {
    ACCOUNTING: "회계",
    ACTION: "작업",
    Add: "추가",
    AddAgent: "에이전트 추가",
    AddArticle: "기사 추가",
    AddBanner: "배너 추가",
    AdditionalContact: "추가 연락처",
    ADDITIONALCONTACT: "추가 연락처",
    ADDITIONALDESCRIPTION: "추가 설명",
    address: "주소",
    administrators: "관리자",
    ADULT: "성인",
    Agencyrate: "대리점 요율",
    AgentInformation: "에이전트 정보",
    AIRCRAFT: "항공기",
    AIRLINES: "항공사",
    AIRPORTTAX: "공항세",
    all: "전체",
    ALLOW_BAG_SEAT: "허용 가방/좌석",
    amount: "금액",
    Amount: "금액",
    ANCILARY: "부가 서비스",
    ANCILLARIES: "부가 서비스",
    APPROVEDBY: "승인자",
    AreYouSure: "확실합니까?",
    Areyousureseat: "좌석을 예약하시겠습니까?",
    ARRIVAL: "도착",
    AVAILABILITY: "가용성",
    Back: "뒤로",
    balance: "발란스",
    Balance: "잔액",
    banner: "배너",
    BasicFare: "기본 요금",
    BIRTHDATE: "생년월일",
    BOOK: "예약",
    BOOKCODE: "예약 코드",
    BOOKDATE: "예약 날짜",
    BOOKEDBY: "예약자",
    BOOKINFO: "예약 정보",
    CABIN: "클래스",
    CALLER: "호출자",
    cancel: "취소",
    CancelBook: "예약 취소",
    CANCELBOOKING: "예약 취소",
    CancelledBasicFare: "취소된 기본 요금",
    CancelledSurchargeFee: "취소된 추가 요금",
    CancelledTerminalFee: "취소된 터미널 요금",
    cancelorder: "주문 취소",
    CheckPrice: "가격 확인",
    checkURLformat: "URL 형식 확인",
    CHILD: "어린이",
    CLASS: "클래스",
    close: "닫기",
    Commissionrebate: "커미션 리베이트",
    Commissionsharing: "커미션 공유",
    Companydetails: "회사 세부 사항",
    confirm: "확인",
    Confirmrefund: "환불 확인",
    CONTACT: "연락처",
    ContactInfo: "연락처 정보",
    Contactphonenumber: "연락처 번호",
    Uploadimages: "콘텐츠",
    corporateName: "회사 이름",
    CREATEBY: "작성자",
    CreateNewBooking: "새 예약 만들기",
    Createrefundform: "환불 양식 작성",
    Creationtime: "생성 시간",
    Currency: "통화",
    DATE: "날짜",
    Deactivate: "비활성화",
    Deductionamount: "금액 공제",
    delete: "삭제",
    Deleteorder: "주문 삭제",
    DEP_ARV: "출발/도착",
    Departure: "출발",
    DEPARTURE: "출발",
    DEPARTUREDATE: "출발 날짜",
    DepartureRouteInfo: "출발 경로 정보",
    Description: "설명",
    DESCRIPTION: "설명",
    DESTINATION: "목적지",
    DESTNATION: "목적지",
    detail: "세부 사항",
    determine: "확인",
    Disablearticles: "핫스팟 켜기",
    Disabled: "사용 안 함",
    DURATION: "기간",
    edit: "편집",
    email: "이메일",
    Email: "이메일",
    Enable: "사용",
    Enablearticles: "기사 활성화",
    EndofTransaction: "거래 종료",
    ETicket: "전자 티켓",
    expenditure: "지출",
    FARE: "요금",
    fast: "빠름,신속",
    FEES: "요금",
    file: "파일",
    FIRSTNAME: "이름",
    FLIGHT: "항공편",
    FLIGHTDATE: "항공편 날짜",
    FLIGHTNUMBER: "항공편 번호",
    global: {
        input_add: "추가",
        input_cancel: "취소",
        input_confirm: "확인",
        input_copy: "복사",
        input_disable: "사용 안 함,장애를입히다",
        input_edit: "편집",
        input_enable: "사용",
        input_export: "수출",
        input_filter: "필터",
        input_search: "검색",
        input_sync: "새로고침",
        label_nav_create: "생성",
        label_nav_edit: "편집",
        label_no: "아니오",
        label_warn: "힌트",
        label_yes: "예",
        lang_cn: "중국어",
        lang_eng: "영어",
        msg_copy_success: "성공적으로 복사됨",
        msg_post_success: "성공적으로 게시됨",
        ph_all: "모두",
        ph_end: "종료 날짜",
        ph_range: "~에",
        ph_start: "시작 날짜",
        require: "입력하세요",
        require_phoneNumber: "올바른 형식의 전화번호를 입력하세요",
		fn_localPrice: '{localPrice,0}',
		fn_tYMD: '{timeYMD,0,1,2}',
		fn_tHM: '{timeHM,0,1}',
		fn_tDate: '{formatDate,0}',
    },
    GROUPNAME: "그룹 이름",
    HandmadePlus: "매뉴얼 추가(?)",
    home: {
        input_account_hint: "재고 SKU/총 SKU",
        input_login: "로그인",
        input_password_hint: "재고 SKU/총 SKU",
        input_remember: "비밀번호 기억하기",
        link_forget: "비밀번호를 잊으셨습니까?",
        link_regist_1: "계정이 없습니까?",
        link_regist_2: "등록",
        require_account: "계정을 입력하세요",
        require_password: "비밀번호를 입력하세요",
        welcome_1: "Fanslink CDMS에 오신 것을 환영합니다",
        welcome_2: ""
    },
    hotspot: "핫스팟",
    income: "수입",
    INFANT: "유아",
    INPUTBY: "입력자",
    INPUTDATE: "입력 날짜",
    INSURANCE: "유류 할증료",
    issuancefailed: "발급 실패",
    issuedsuccessfully: "발급 성공",
    Keberangkatan: "출발",
    LASTNAME: "성",
    Loginaccount: "로그인 계정",
    macroMutexSelector: "macromutex 선택",
    Manualdeduction: "매뉴얼 공제(?)",
    Mobile: "휴대폰 번호",
    MOBILE: "전화번호",
    MODIFICATION: "수정",
    ModifyRefundLimit: "환불 한도 수정",
    MyBookings: "내 예약",
    name: "이름",
    Name: "이름",
    nationality: "국적",
    NATIONALITY: "국적",
    NewBooking: "새 예약",
    NEWREFUNDLIMIT: "새로운 환불 한도",
    No: "아니오",
    NO: "정상",
    normal: "정상",
    notIncomplete: "완성",
    NUMERICCODE: "숫자 코드",
    objective: "목적",
    OddNumbers: "주문 번호",
    OFFICE: "사무실",
    open: "열기",
    operation: "운영",
    Ordercompleted: "주문 완료",
    Orderrefund: "주문 환불",
    ORIGIN: "출발지",
    ORNUMBER: "OR 번호",
    OTHERFEE: "기타 요금",
    Otherrefunds: "기타 환불",
    OUTSTANDING: "금액",
    pagination: {
        label_total: "페이지당 총 (0)"
    },
    PASSENGER: "승객",
    PassengerInfo: "승객 정보",
    PASSENGERNAME: "승객 이름",
    PASSENGERS: "승객",
    PASSPORT: "여권",
    PASSPORTEXPDATE: "여권 만료일",
    PASSPORTEXPIRYDATE: "여권 만료일",
    PASSPORTNUMBER: "여권 번호",
    password: "비밀번호",
    PAX: "승객",
    PaxInfo: "승객 정보",
    PAXTYPE: "승객 유형",
    Payment: "결제",
    PAYMENT: "결제",
    PaymentHistory: "결제 내역",
    PaymentOrder: "결제 주문",
    Pendingrefund: "환불 대기",
    Pendingreview: "검토 중",
    phone: "전화번호",
    picture: "사진",
    Pleaseamount: "환불 금액",
    PleaseConfirm: "확인",
    Pleaseenter: "입력",
    pleasefeeslist: "확인 수수료 목록 ",
    pleasereason: "확인 이유",
    Pleaseupload: "업로드",
    PREPAIDBAGGAGE: "사전 결제 수하물",
    PreviousBalance: "이전 잔액",
    PRINTBOOKING: "예약 인쇄",
    Printltinerary: "전체 일정 인쇄",
    PRINTPNR: "PNR 인쇄",
    PrintSMTicket: "SM 티켓 인쇄",
    PRMOMCODE: "프로모션 코드",
    prompt: "프롬프트",
    PULANGPERGI: "왕복",
    query: "질문 ",
    reason: "이유",
    REASON: "이유",
    ReBookFee: "재예약 요금",
    RebookInfo: "재예약 정보",
    Recharge: "재충전",
    Rechargedetails: "재충전 상세",
    Rechargerecords: "충전 기록",
    Refund: "환불",
    REFUND: "환불",
    RefundableAmount: "환불 가능 금액",
    REFUNDABLES: "환불 가능",
    refundamount: "환불 금액",
    Refundcompleted: "환불 완료",
    Refundfailed: "환불 실패",
    RefundFee: "환불 수수료",
    RefundLimit: "환불 한도",
    Refusalrefund: "환불 불가",
    refuse: "거부",
    region: "지역",
    Remarks: "비고",
    ReprintReceipt: "영수증 재발행",
    RESERVESEAT: "좌석 예약",
    Restrictsales: "판매 제한",
    Returndate: "귀국 날짜",
    role: "역할",
    ROUTE: "경로",
    RouteInfo: "경로 정보",
    SATUARAH: "편도",
    SEAT: "좌석",
    Seatfailed: "좌석 예약 실패",
    SeatReserved: "예약된 좌석",
    seatsuccessful: "좌석 예약 성공",
    Selectendtime: "종료 시간",
    Selectstarttime: "시작 시간",
    SERVICEDAY: "서비스 요일",
    ShowRemarksInfo: "비고 정보 표시",
    sort: "정렬",
    state: "상태",
    STATUS: "상태",
    SURCHARGE: "추가 요금",
    SurchargeFee: "추가 요금",
    surplus: "나머지,잔여,흑자",
    TCP: "TCP 완료 일행,단체(?)",
    TerminalFee: "터미널 요금",
    TERMINALFEE: "터미널 요금",
    TICKETING: "티켓 발권",
    ticketNo: "티켓 번호",
    TICKETNUMBER: "티켓 번호",
    time: "시간",
    TIMELIMIT: "제한 시간",
    title: "제목",
    TITLE: "직함,직책",
    TKTNUMBER: "티켓 번호",
    tocontinue: "계속",
    TopUp: "잔액",
    TOTAL: "합계",
    Totalcost: "총 비용",
    TotalPreviousPayment: "이전 총 결제",
    TOTALPRICE: "총 가격",
    TRAMSIT: "환승",
    TRANSACTIONDATE: "거래 날짜",
    TRANSIT: "환승",
    Turnoffhotspot: "핫스팟 끄기",
    Turnonhotspot: "핫스팟 끄기",
    type: "유형",
    uac: {
        enum_invalid: "무효",
        enum_valid: "유효",
        input_cancle: "취소",
        input_confirm: "확인",
        input_create: "부서 추가",
        input_del: "삭제",
        label_add: "추가",
        label_add_part: "부서 추가",
        label_delete_depart: "부서 삭제",
        label_delete_role: "역할 삭제, 담당 삭제",
        label_delete_user: "사용자 삭제",
        label_department: "소속 부서",
        label_edit: "편집",
        label_edit_part: "부서 편집",
        label_email: "직원 이메일",
        label_employeeId: "직원 ID",
        label_login: "로그인",
        label_menu: "메뉴",
        label_mobile: "직원 전화번호",
        label_name: "직원 이름",
        label_partname: "부서 이름",
        label_password: "비밀번호",
        label_remark: "비고",
        label_repeat_password: "비밀번호 반복",
        label_role: "사용자 역할",
        label_roleName: "역할 이름(담당자 성함)",
        label_warn: "경고",
        ph_depart: "부서",
        ph_role: "역할",
        ph_userName: "사용자 이름",
        require_doublepassword: "비밀번호 재입력",
        require_employeename: "직원 이름 입력",
        require_employeenumber: "직원 번호 입력",
        require_nomatch_password: "비밀번호가 일치하지 않습니다",
        require_password: "비밀번호 입력",
        require_select_role: "사용자 역할 입력",
        require_username: "사용자 이름 입력",
        th_authType: "역할(담당,임무) 유형",
        th_createTime: "생성 시간",
        th_depart: "부서",
        th_email: "이메일",
        th_mobile: "휴대폰 번호",
        th_nums: "총 사용자 수",
        th_oparate: "작업,운영",
        th_partname: "부서 이름",
        th_remark: "비고",
        th_roleName: "역할 이름",
        th_sharp: "",
        th_status: "상태",
        th_userName: "사용자 이름"
    },
    Unavailable: "사용 불가",
    UpdateAgent: "업데이트 에이전트",
    UpdateArticle: "기사 업데이트",
    UpdateBanner: "배너 업데이트",
    content: "이미지 업로드",
    user: "사용자",
    Userapplication: "사용자 신청",
    USERID: "사용자 ID",
    VALID: "유효",
    VALIDDATE: "유효 날짜",
    VALIDTY: "유효성",
    VAT: "부가가치세",
    VIEWPNR: "PNR 보기",
    VIEWSCHEDULE: "일정 보기",
    warehouse: {
        channel: {
            ph_search_channelwhs: "채널(경로의) 창고(의) 이름을 입력하세요",
            th_channel: "판매 채널",
            th_checkin: "입고 대기 중",
            th_freezed: "동결된 재고",
            th_mark: "비고",
            th_name: "채널 위치",
            th_number: "",
            th_realwhs: "소속된 실제 창고",
            th_skuRatio: "재고 SKU/총 SKU",
            th_sold: "역사적 판매량"
        },
        enum_disable: "사용 안 함",
        enum_normal: "정상",
        input_cancel: "취소",
        input_create: "생성",
        label_cancelTime: "취소",
        label_mark: "비고",
        ph_datePicker_end: "종료 날짜",
        ph_datePicker_range: "~에",
        ph_datePicker_start: "시작 날짜",
        real: {
            ph_search_realwhs: "물리적(실제) 창고의 이름을 입력하세요",
            th_address: "창고 주소",
            th_channelRef: "채널 위치",
            th_checkin: "입고 대기 중",
            th_contact: "창고 연락처",
            th_freezed: "동결된 재고",
            th_name: "물리적(실제) 창고",
            th_number: "",
            th_skuRatio: "재고 SKU/총 SKU",
            th_sold: "역사적 판매량"
        },
        td_del: "삭제",
        td_edit: "편집",
        th_oper: "작업",
        th_state: "상태",
        warn_noSel: "먼저 항목을 선택하십시오",
		Agentcode: "대리점 코드",
    },
    Yes: "예",
	Agentcode: "대리점 코드",
	Agentlist: "대리점 목록",
	Reductions:"이체",
	Transferin:"전입",
	Transferout:"전출",
	operate:"작업",
	Resendticket: "전자 항공권 재발송",
	travelTax: "여행비",
	webFee: "주문 서비스 요금",
	Abandoned:"폐표",
	Auditing:"감사",
	flightawaiting: "항로 삭제 성공, 심사 대기 중",
	flightFailed: "세그먼트 삭제 실패",
	pnrawaiting: "PNR 삭제 성공, 보류 중",
	pnrdeletion: "PNR 삭제 실패",
	Invalidticketfailed: "폐표 실패",
	Pendingpayment: "미지급",
	Flowtype: "흐름 유형",
	Businesstype: "비즈니스 유형",
	Uploadfiles: "파일 업로드",
	CancelTime: "취소 시간",
	agent: "대리상",
	subagent: "하위 에이전트",
	RETURN:'반환',
	ADDCITY:'신규 항로',
	MULTICITY:"다도시",
	ReturningRouteInfo:"귀환 경로 정보",
	PriceInfo:"가격 조정 정보",
	NEXT:"다음",
	TYPE:"유형",
	SPECIALASSISTANCEREQUIRED:"특별 지원 유형",
	areaCode:"국가 코드",
	SSRS:'SSRS',
	PRICE:"가격",
	Pleaseselectrefund:"환불 구간을 선택하십시오.",
	Pleaseprovidecomplete:"전체 입력",
	Orderexceedslimit:'주문이 한도를 초과하다',
	NonRefundable:'환불 불가',
	Expiredthevalidityperiod:'유효 기간이 이미 지났다.',
	seatNum:'좌석 수',
	Pleaseselect:'선택하십시오.',
	Pleasereschedulingdate:'변경 날짜를 선택하십시오.',
	Pleaserescheduleflightsegment:'변경 항로를 선택하십시오.',
	Cannotbechanged:'변경할 수 없음',
	Areyousuretodelete:'삭제하시겠습니까?',
	cannotrefunded:'이 항공편은 환불할 수 없습니다.',
	operator:'운영자',
	Pleaseenteryouremailaddress:'메일박스 입력',
	refreport:'보고서를 반환하다.',
	salreport:'영업 보고서',
	uplreport:'운송 보고서',
	Actualtakeoffstarttime:'실제 이륙 시작 시간',
	Actualtakeoffendtime:'실제 이륙 종료 시간',
	Doistarttime:'Doi 시작 시간',
	Doiendtime:'Doi 종료 시간',
	Plannedarrivalendtime:'예정 도착 종료 시간',
	Pleaseselectstartandenddates:'시작 및 종료 날짜를 선택하십시오.',
	PleaseselectDoitakeofftime:'Doi 시작 종료 시간 또는 이륙 시작 종료 시간을 선택하십시오.',
	noshowreport:'제곱 보고서',
	UndefinedReport:'특별 보고서',
	imageuploadTypeTip:'그림만 올릴 수 있어요.',
	imageuploadSizeTip:'그림 크기는 2MB를 초과할 수 없습니다.',
    // 本地化函数
    _f: {
        localPrice: (price: number) => {
            if (typeof price !== 'number') {
                return '';
            }

            let minus = price < 0;
            let price100x = Math.abs(Math.floor(price * 100 + 0.5));

            const floatPart = price100x % 100
            price100x = Math.floor(price100x / 100);

            const intPart: string[] = [];

            while (price100x > 999) {
                intPart.unshift((price100x % 1000).toString().padStart(3, '0'));
                price100x = Math.floor(price100x / 1000);
            };

            intPart.unshift(price100x.toString());
            return `${minus ? '-' : ''}${intPart.join(',')}.${floatPart.toString().padStart(2, '0')}`;
        },
        timeYMD: (y: number, mn: number, d: number) => {
            const formatNumber = dlc._f.formatNumber;
            return `${y}-${formatNumber(mn)}-${formatNumber(d)}`;
        },
        timeHM: (h: number, m: number) => {
            const formatNumber = dlc._f.formatNumber;
            return `${formatNumber(h)}:${formatNumber(m)}`;
        },
        formatDate: (date: Date) => {
            const formatNumber = dlc._f.formatNumber;
            const y = date.getFullYear();
            const mn = formatNumber(date.getMonth() + 1);
            const d = formatNumber(date.getDate());
            const h = formatNumber(date.getHours());
            const m = formatNumber(date.getMinutes());
            const s = formatNumber(date.getSeconds());

            return `${y}-${mn}-${d} ${h}:${m}:${s}`;
        },
        formatNumber: (n: number) => {
            return n.toString().padStart(2, '0')
        }
    }
}

type LangPack = typeof dlc;

export type I18nBase = Exclude<PickKeyOfObject<LangPack>, 'global' | '_f'>
export type I18nExtend<T extends keyof LangPack> = PickKeyOfObject<LangPack[T]>

export type LangNsp = PickObjectRecursive<typeof dlc>

export default { dlc };